import type { ReactNode } from 'react';

export function ParsedSection({ title, icon, children }: { title: string; icon: ReactNode; children: ReactNode }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sm font-semibold text-gray-700 border-b border-gray-100 pb-1">
        {icon}
        {title}
      </div>
      {children}
    </div>
  );
}

export function TagList({ items }: { items: string[] }) {
  if (!items?.length) return <span className="text-sm text-gray-400">&mdash;</span>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((item, i) => (
        <span key={i} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
          {item}
        </span>
      ))}
    </div>
  );
}

export function BulletList({ items }: { items: string[] }) {
  if (!items?.length) return <span className="text-sm text-gray-400">&mdash;</span>;
  return (
    <ul className="space-y-1">
      {items.map((item, i) => (
        <li key={i} className="flex gap-2 text-sm text-gray-700">
          <span className="text-orange-500 flex-shrink-0 mt-0.5">&bull;</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
